import { Injectable } from '@angular/core';
import { ApiBaseService } from './api-base.service';
import { HttpClient, HttpParams } from '@angular/common/http';
import { ErrorService } from '../error/error.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';
import { map, share } from 'rxjs/operators';
import { User } from 'src/app/shared/models/users/user';
import { UserPassword, UserSetting } from 'src/app/shared/models/users/signupUser';
import { UserSearchResults } from 'src/app/shared/models/users/usersSearchResults';
import { SearchParams } from 'src/app/shared/models/searchParams';

@Injectable({
    providedIn: 'root'
})
export class UsersApiService extends ApiBaseService {

    baseUrl = environment.backend_host + '/api';

    constructor(
        public http: HttpClient,
        protected errorService: ErrorService,
        protected spinner: NgxSpinnerService) {
        super(spinner, errorService);
    }
    // Users
    public getStaffUsers = (params: SearchParams): Observable<UserSearchResults> => {
        const p = this.serializeParamsObj(params, new HttpParams());
        return this.http.get<any>(`${this.baseUrl}/users/`, { params: p })
            .pipe(map(this.deserializeAs(UserSearchResults)))
    }
    public getUser = (id: number): Observable<User> =>
        this.http.get<any>(`${this.baseUrl}/users/${id}`)
            .pipe(map(this.deserializeAs(User)))

    public getUserSettings = (): Observable<UserSetting> =>
        this.http.get<any>(`${this.baseUrl}/users/settings`)
            .pipe(map(this.deserializeAs(UserSetting)))

    public updateUserSettings = (user: UserSetting): Observable<UserSetting> =>
        this.http.put<any>(`${this.baseUrl}/users/settings`, this.serialize(user))
            .pipe(map(this.deserializeAs(UserSetting)))

    public updateUserPassword = (userPassword: UserPassword): Observable<any> =>
        this.http.put<any>(`${this.baseUrl}/users/change-password`, this.serialize(userPassword))


    public createUser = (user: User): Observable<User> =>
        this.http.post<any>(`${this.baseUrl}/users/`, this.serialize(user))
            .pipe(map(this.deserializeAs(User)))

    public updateUser = (user: User): Observable<User> =>
        this.http.put<any>(`${this.baseUrl}/users/${user.id}`, this.serialize(user))
            .pipe(map(this.deserializeAs(User)))

    public deleteUser = (id: number): Observable<User> =>
        this.http.delete<any>(`${this.baseUrl}/users/${id}`)
            .pipe(share())

    public checkUsernameAvailability(username: string): Observable<any> {
        return this.http.get<any>(`${this.baseUrl}/users/username/${username}`)
            .pipe(share());
    }

    public checkPhoneNumberAvailability(phone: string): Observable<any> {
        return this.http.get<any>(`${this.baseUrl}/users/phone/${phone}`)
            .pipe(share());
    }

    public checkEmailAvailability(email: string): Observable<any> {
        return this.http.get<any>(`${this.baseUrl}/users/email/${email}`)
            .pipe(share());
    }

    public getAdminDashboardData(): Observable<any> {
        return this.http.get<any>(`${this.baseUrl}/dashboard/admin`)
            .pipe(share());
    }

    public uploadUserProfileImg = (formData: FormData): Observable<any> =>
        this.http.put(`${this.baseUrl}/users/upload-img`, formData).pipe(share())
}